// Phase 1 read-only editor: mounts MDXEditor (Lexical) with the full
// directive-descriptor stack and applies normalizeAgentMarkdown upstream
// so corpus content's :::widget[X]::: single-line form parses as actual
// directive nodes (textDirective post-normalize) rather than raw text.
//
// frontmatterPlugin is required because ~30 cells in content/ start with
// a YAML `--- … ---` block. Without the plugin, the parser treats the
// opening `---` as a thematic break and the closing `---` as a setext
// underline, swallowing the entire YAML body into a multi-line H2 and
// breaking the visual layout of the cell body that follows.

import {
  MDXEditor,
  directivesPlugin,
  frontmatterPlugin,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  tablePlugin,
  thematicBreakPlugin,
  codeBlockPlugin,
  linkPlugin,
} from '@mdxeditor/editor';
import { normalizeAgentMarkdown } from '@rmint/core/directives/normalize-agent-markdown';
import { widgetDirectiveDescriptors } from './plugins/widget-descriptors';
import { displayDirectiveDescriptors } from './plugins/display-descriptors';
import { slotDirectiveDescriptor } from './plugins/slot-descriptor';

export interface ReadOnlyEditorProps {
  markdown: string;
}

export function ReadOnlyEditor({ markdown }: ReadOnlyEditorProps) {
  const normalized = normalizeAgentMarkdown(markdown);
  return (
    <MDXEditor
      markdown={normalized}
      readOnly
      plugins={[
        headingsPlugin(),
        listsPlugin(),
        quotePlugin(),
        tablePlugin(),
        thematicBreakPlugin(),
        codeBlockPlugin(),
        linkPlugin(),
        frontmatterPlugin(),
        directivesPlugin({
          directiveDescriptors: [
            ...widgetDirectiveDescriptors,
            ...displayDirectiveDescriptors,
            slotDirectiveDescriptor,
          ],
        }),
      ]}
    />
  );
}
